<script>
  export let title = ""
  export let index
  export let certActive
  export let isFinal = false
  export let toggleSwitch = false
</script>

{#if !toggleSwitch || (toggleSwitch && index <= certActive)}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    on:click={() => {
      if (index != certActive) {
        if (!isFinal && !toggleSwitch) toggleSwitch = true
      } else {
        if (!isFinal) toggleSwitch = !toggleSwitch
      }
      certActive = index
    }}
    style="margin-left: {index * 20}px;"
    class="relative flex w-max cursor-pointer items-center gap-3 rounded-md {certActive == index ? 'bg-green-500/25' : 'bg-white hover:bg-green-500/25 dark:bg-[#292a2f] hover:dark:bg-green-500/25'} px-3 py-2 font-medium text-black dark:text-white"
  >
    {#if index != 0}
      <div class="absolute -top-[40%] -left-5 z-10 h-9 w-5 border-2 border-t-0 border-r-0 border-dashed border-[#96B3FF]" />
    {/if}
    <button type="button" class="{certActive == index ? 'bg-green-500' : 'bg-[#96B3FF]'} {isFinal ? 'invisible' : ''} flex items-center justify-center rounded-md px-1 py-0.5 text-xs last:invisible">
      <span>
        <i class="fa-solid {toggleSwitch && certActive == index ? 'fa-plus' : 'fa-minus'}" />
      </span>
    </button>
    <span>{title || "-"}</span>
  </div>
{/if}
